import {
  ADD_APPROVAL,
  ADD_MESSAGE,
  CLOSE_APPROVAL,
  CLOSE_MESSAGE,
} from './types';

export const addApproval = (approval: {
  callback: () => void;
  message: string;
}): {
  type: string;
  approval: {
    callback: () => void;
    message: string;
  };
} => ({
  type: ADD_APPROVAL,
  approval,
});

export const addMessage = (
  message: string
): {
  type: string;
  message: string;
} => ({
  type: ADD_MESSAGE,
  message,
});

export const closeApproval = (): { type: string } => ({
  type: CLOSE_APPROVAL,
});

export const closeMessage = (): { type: string } => ({
  type: CLOSE_MESSAGE,
});
